import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { ORGANIZATION_PEOPLE_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function update_event_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(ORGANIZATION_PEOPLE_CACHE_FIELDS, cache);
}
